export enum RecapItem {
    Delivery = "D",
    Return = "R"
}